// GTM (GTM-N795TTTG) maps the `vte_registration` dataLayer event to the GA4 `sign_up`
// event, which Google Ads imports as the "VTE - Sign-up" conversion. Push it once per
// account: email sign-ups at register time, OAuth sign-ups on /auth/callback.

export type RegistrationMethod = 'email' | 'google' | 'facebook'

type DataLayerHost = { dataLayer?: unknown[] }

export function pushRegistrationConversion(
  method: RegistrationMethod,
  host: DataLayerHost = window as unknown as DataLayerHost,
): void {
  host.dataLayer = host.dataLayer || []
  host.dataLayer.push({ event: 'vte_registration', method })
}

/**
 * The API appends `new_user=1&method=<provider>` to the /auth/callback fragment only
 * when the OAuth request created the account. Logins, account linking and email
 * verification (already counted at register time) return null.
 */
export function oauthSignupMethod(params: URLSearchParams): 'google' | 'facebook' | null {
  if (params.get('new_user') !== '1') return null
  const method = params.get('method')
  return method === 'google' || method === 'facebook' ? method : null
}
